import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { IChatConversation } from '@fi-shared/fi-chat/fi-chat';
import { FicScreenContentBase } from '@fi-shared/fic-screen/fic-screen-content-base';
import { ManageUsersStep } from '@fi-shared/fi-chat/fi-chat-conversation-manage-type';
import { AppTextService } from '@fi-shared/app-text';
import { isDefined } from '@fi-shared/utils';

export interface FiChatConversationManageUsersScreenData {
    conversation$: Subject<IChatConversation>;
    manageUsersStep: ManageUsersStep;
}

@Component({
    selector: 'fi-chat-conversation-manage-users-screen',
    template: `
        @if (data.conversation$ | async; as conversation) {
          <fic-screen>
            <fic-screen-header>
              <fic-screen-header-prefix>
                @if (isRemoveStep()) {
                  <fic-screen-btn-close></fic-screen-btn-close>
                }
                @if (!isRemoveStep()) {
                  <button
                    mat-icon-button
                    class="fi-content-card-top-button"
                    (click)="setCurrentStep(manageUsersStep.Remove)"
                    >
                    <mat-icon class="fas fa-chevron-left"></mat-icon>
                  </button>
                }
              </fic-screen-header-prefix>
              <span class="conversation-manage-users-header-text">{{ getHeaderText() }}</span>
              @if (isRemoveStep()) {
                <button
                  mat-button
                  class="conversation-control-button"
                  (click)="setCurrentStep(manageUsersStep.AddMore)"
                  >
                  {{ 'common.add_more' | fiAppText }}
                </button>
              }
            </fic-screen-header>
            <fic-screen-content>
              <fi-chat-conversation-manage-users
                [currentManageUsersStep]="currentManageUsersStep"
                [conversation]="conversation"
                [addUsers$]="addUsers$.asObservable()"
                (selectedUsersChange)="selectedUsersChange($event)"
                (close)="onConversationUsersChange()"
                >
              </fi-chat-conversation-manage-users>
            </fic-screen-content>
          </fic-screen>
        }
        `,
    styleUrls: ['./fi-chat-conversation-manage-users-screen.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-manage-users-screen' },
    standalone: false,
})
export class FiChatConversationManageUsersScreenComponent
    extends FicScreenContentBase<FiChatConversationManageUsersScreenData>
    implements OnInit
{
    appText = this.injector.get(AppTextService);
    currentManageUsersStep = ManageUsersStep.Remove;
    manageUsersStep = ManageUsersStep;
    addUsers$ = new Subject<void>();
    newUsersAmount: number;

    ngOnInit() {
        if (isDefined(this.data.manageUsersStep)) this.currentManageUsersStep = this.data.manageUsersStep;
    }

    setCurrentStep(step: number) {
        this.currentManageUsersStep = step;
    }

    selectedUsersChange(newUsersAmount: number) {
        this.newUsersAmount = newUsersAmount;
    }

    onAddingConversationUser() {
        this.addUsers$.next();
    }

    onConversationUsersChange() {
        this.closeScreen();
    }

    isRemoveStep(): boolean {
        return this.currentManageUsersStep === ManageUsersStep.Remove;
    }

    getHeaderText(): string {
        return this.isRemoveStep() ? this.appText.get('common.members') : this.appText.get('common.add_members');
    }
}
